import { Injectable } from '@angular/core';

import { HttpService } from '@/app/core/services/http';

import {
  User,
  CreateUserPayload,
  UpdateUserPayload,
  UserListQueryParams,
  UsersFiltersQueryParams,
  ResetUserPasswordPayload,
} from './users.types';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private http: HttpService) {}

  getUsers(queryParams: UserListQueryParams) {
    return this.http.getList<User>('/v1/users', {
      params: queryParams,
    });
  }

  getPaginatedUsers(queryParams: UserListQueryParams) {
    return this.http.getPaginatedList<User>('/v1/users', {
      params: queryParams,
    });
  }

  createUser(payload: CreateUserPayload) {
    return this.http.post<User>('/v1/users', payload);
  }

  updateUser(id: number, payload: UpdateUserPayload) {
    return this.http.put<User>(`/v1/users/${id}`, payload);
  }

  resetUserPassword(id: number, payload: ResetUserPasswordPayload) {
    return this.http.put<User>(`/v1/users/${id}/password`, payload);
  }

  getUsersFilters(params?: UsersFiltersQueryParams) {
    return this.http.getFilters('/v1/users/filters', { params });
  }

  deleteUser(id: number) {
    return this.http.delete<null>(`/v1/users/${id}`);
  }
}
